import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { SectionHeading, Reveal } from "./Reveal";
import { FAQS } from "../../data/content";

export const Faq = () => {
    return (
        <section id="faq" data-testid="faq-section" className="relative bg-ivory py-28 lg:py-36">
            <div className="mx-auto max-w-3xl px-6 lg:px-10">
                <SectionHeading eyebrow="Questions, Answered" title="Everything You Wonder, Gently Answered" />
                <Reveal className="mt-14">
                    <Accordion type="single" collapsible data-testid="faq-accordion">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`faq-${i}`}
                                className="border-gold/30"
                                data-testid={`faq-item-${i}`}
                            >
                                <AccordionTrigger
                                    className="py-6 font-serif text-lg text-emerald hover:text-gold hover:no-underline sm:text-xl"
                                    data-testid={`faq-trigger-${i}`}
                                >
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent
                                    className="pb-6 font-sans text-sm leading-relaxed text-emerald/75 sm:text-base"
                                    data-testid={`faq-content-${i}`}
                                >
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
                <Reveal delay={0.15} className="mt-12 text-center">
                    <p className="font-script text-2xl text-emerald/80 sm:text-3xl">
                        Still wondering? <a href="#contact" className="text-gold underline decoration-gold/40 underline-offset-4 transition-colors hover:text-emerald">Write to us</a> — we adore a good question.
                    </p>
                </Reveal>
            </div>
        </section>
    );
};
